<template>
  <v-app>
    <v-container fluid class="grey fill-height d-flex justify-center align-center">
      <v-card 
        class="elevation-8" 
        max-width="600"
        :loading="loading"
        flat 
        tile 
      >
        <v-card-text class="py-10">
          <div class="d-flex flex-column justify-center text-center">
            <img class="mx-auto my-5" src="@/assets/images/symbol.gif" width="150">
            <h1>กองบริหารงานบุคคล มรภ.สุรินทร์</h1>
            <v-text-field
              class="mt-5"
              label="ชื่อผู้ใช้"
              v-model="username"
              prepend-inner-icon="mdi-account"
              @focus="showError = false; errorText = ''"
              solo
            ></v-text-field>
            <v-text-field
              label="รหัสผ่าน"
              v-model="password"
              :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
              prepend-inner-icon="mdi-key"
              :type="show_password ? 'text' : 'password'"
              @click:append="show_password = !show_password"
              @focus="showError = false; errorText = ''"
              solo
            ></v-text-field>
            <h4 class="text-left red--text" v-if="show_error_message">*{{ error_message }}</h4>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block tile :disabled="loading" @click="login">เข้าสู่ระบบ</v-btn>
        </v-card-actions>
        <v-card-subtitle>
          <p class="font-weight-black"><strong class="text-decoration-underline">หมายเหตุ</strong> บุคลากรสามารถเข้าใช้งานระบบนี้ได้โดยใช้ Username และ Password เดียวกันกับที่ใช้ในการ Login เข้าใช้งาน Internet ของมหาวิทยาลัย</p>
        </v-card-subtitle>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    // username: 'pattarapatwaidee',
    // password: 'good2cu',
    username: '',
    password: '',
    show_password: false,
    show_error_message: false,
    error_message: ''
  }),
  computed: {
    validate() {
      return this.username !== '' && this.password !== '';
    }
  },
  methods: {
    login() {
      this.loading = true;

      this.$store.dispatch('auth/login', { username: this.username, password: this.password })
        .then(() => {
          this.loading = false;
          this.$router.push({ name: 'Home' });
        }).catch(res => {
          this.loading = false;
          this.show_error_message = true;
          this.error_message = res.message;
        });
    },
    showSnackbar(data) {
      this.snackbar = {
        show: true,
        text: data.text,
        color: data.color
      }
    }
  }
}
</script>